export { default } from "./VerticalVideoCard";
